<template>
  <div class="panel panel-default">
    <div class="panel-body">
      <div
        class="panel-header"
        :class="{ clickable: hasContentToggle }"
        :role="hasContentToggle ? 'button' : undefined"
        :tabindex="hasContentToggle ? 0 : undefined"
        :aria-expanded="hasContentToggle ? showContent : undefined"
        @click="hasContentToggle && $emit('toggle', !showContent)"
        @keydown.enter.prevent="hasContentToggle && $emit('toggle', !showContent)"
        @keydown.space.prevent="hasContentToggle && $emit('toggle', !showContent)"
      >
        <slot name="header">
          <h2 v-if="hasHeaderContent">
            <i v-if="icon" :class="iconClass" aria-hidden="true"></i>
            {{ title }}
            <i v-if="hasContentToggle" :class="toggleClass" class="content-toggle" aria-hidden="true"></i>
          </h2>
        </slot>
      </div>
      <!-- Lazy: mount only when expanded -->
      <div v-if="lazyBody && showContent" class="panel-content">
        <slot name="body"></slot>
      </div>
      <!-- Non-lazy: always mounted -->
      <div v-else-if="!lazyBody" v-show="showContent" class="panel-content">
        <slot name="body"></slot>
      </div>
      <!-- When the panel body is collapsed -->
      <div v-if="!showContent" class="panel-content default">
        <slot name="content-hidden">
          <span>Content is hidden, click to expand.</span>
        </slot>
      </div>
    </div>
  </div>
</template>

<style scoped>
.panel-header {
  align-items: center;
}

.panel-header.clickable {
  cursor: pointer;
}

.content-toggle {
  font-size: 1.2em;
  font-weight: bold;
  color: var(--kate-type-primary);
  float: right;
  cursor: pointer;
  pointer-events: none;
}

.panel-header.clickable:hover .content-toggle {
  color: var(--kate-type-secondary);
}
</style>

<script>

export default {
  props: {
    title: {
      type: String,
    },
    hasContentToggle: {
      type: Boolean,
      default: true,
    },
    showContent: {
      type: Boolean,
      default: true,
    },
    lazyBody: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
    },
    duotone: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    hasHeaderContent() {
      return this.title || this.icon || this.hasContentToggle;
    },
    toggleClass() {
      return `fas fa-angle-${this.showContent ? 'up' : 'down'}`;
    },
    iconClass() {
      return this.icon ? `k-asset-icon ${this.icon} ${this.duotone ? 'fa-duotone' : 'fas'}` : undefined;
    },
  },
};
</script>
